import utility from 'src/utils/utility'
import axios, { AxiosRequestConfig } from 'axios'
import { CONSTANTs, url } from 'src/provider/config/constant'

export const adminApiCaller = axios.create({
    baseURL:  url.ADMIN_BASE_URL 
})

adminApiCaller.interceptors.request.use(
    async (config: AxiosRequestConfig<any>) => {
        const token = await localStorage.getItem('authToken')
        
        if(token && token != 'null') {
            config.headers!.Authorization = `Bearer ${token}`
        }
        else {
            config.headers = {
                clientId: CONSTANTs.clientId,
                signature: utility.getSignature()
            }
        }
        
        return config;
    },

    (err) => {
        return Promise.reject(err)
    }
)

//export default adminInstance